<template lang="pug" src="./templates/DeleteAddressModal.pug"></template>

<script>
import notify from '../notify';

export default {
  props: {
    name: {
      type: String,
      default: 'delete-address-modal',
    },
    type: {
      type: String,
      required: true,
    },
    address: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async onSubmit() {
      try {
        await this.$store.dispatch(`account/delete_${this.type}_address`, this.address);
        notify.success(this, { title: Lang.get('alerts.general.operation_completed') });
        this.$emit('deleted', this.address);
      } catch (e) {
        notify.errors(this, e);
      }
    },
  },
};
</script>
